module.exports = __webpack_public_path__ + "static/media/givein.dafa3f48.png";